import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import ListIcon from '@material-ui/icons/List';
import UpdateIcon from '@material-ui/icons/Update';

const wizardRouteRef = createRouteRef();
const myRequestsRouteRef = createRouteRef();
const approvalRouteRef = createRouteRef();

const keepVmRunningPage = PageBlueprint.make({
  name: 'keep-vm-running',
  params: {
    path: '/keep-vm-running',
    routeRef: wizardRouteRef,
    title: 'VM Extensions',
    icon: <UpdateIcon />,
    noHeader: true,
    loader: () =>
      import('./pages/KeepVmRunningWizardPage').then(m => (
        <m.KeepVmRunningWizardPage />
      )),
  },
});

const myRuntimeExtensionRequestsPage = PageBlueprint.make({
  name: 'keep-vm-running-requests',
  params: {
    path: '/keep-vm-running/requests',
    routeRef: myRequestsRouteRef,
    title: 'VM Extensions Requests',
    icon: <ListIcon />,
    noHeader: true,
    loader: () =>
      import('./pages/MyRuntimeExtensionRequestsPage').then(m => (
        <m.MyRuntimeExtensionRequestsPage />
      )),
  },
});

// Where Slack's "Approve"/"Reject" links land — not given a `title`/`icon`,
// so it never shows up as its own sidebar entry (matches the infrastructure
// plugin's own request-detail/instance-detail pages).
const approvalPage = PageBlueprint.make({
  name: 'keep-vm-running-approval',
  params: {
    path: '/keep-vm-running/requests/:requestId',
    routeRef: approvalRouteRef,
    noHeader: true,
    loader: () =>
      import('./pages/RuntimeExtensionApprovalPage').then(m => (
        <m.RuntimeExtensionApprovalPage />
      )),
  },
});

export const runtimeExtensionPlugin = createFrontendPlugin({
  pluginId: 'runtime-extension',
  extensions: [keepVmRunningPage, myRuntimeExtensionRequestsPage, approvalPage],
});
